import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';

class RoomTypeStore {

    // Properties

    // Modal Create/Update Properties

    @observable showRoomTypeModal = false;
    @observable roomTypeTitle = '';

    @observable roomTypes = [];
    @observable roomTypeId = 0;
    @observable roomTypeName = '';
    @observable roomTypeTextButton = 'Create';

    // Helper Properties

    @observable roomTypeListLoading = false;
    @observable roomTypeModalLoading = false;

    // Initialization

    @action initRoomType() {
        this.roomTypeListLoading = true;

        ApiCaller.RoomSetups.apiGetRoomTypes().then(roomTypeResponses => {
            if (!roomTypeResponses.isError) {
                this.roomTypes = roomTypeResponses.data;
            } else {
                this.roomTypes = [];
            }
            
            this.roomTypeListLoading = false;
        });
    }

    @action initCreateRoomType() {
        this.roomTypeTitle = 'Create Room Type';

        this.roomTypeId = 0;
        this.roomTypeName = '';

        this.roomTypeTextButton = 'Create';
        this.showRoomTypeModal = true;
    }

    @action initUpdateRoomType(roomTypeId) {
        this.roomTypeModalLoading = true;
        this.roomTypeTitle = 'Update Room Type';
        this.roomTypeTextButton = 'Update';
        this.showRoomTypeModal = true;

        ApiCaller.RoomSetups.apiGetRoomTypeById(roomTypeId).then(roomTypeResponse => {
            if (!roomTypeResponse.isError) {
                if (roomTypeResponse.data) {
                    this.roomTypeId = roomTypeResponse.data.roomTypeId;
                    this.roomTypeName = roomTypeResponse.data.roomTypeName;
                } else {
                    this.roomTypeId = 0;
                    this.roomTypeName = '';
                }
            } else {
                this.roomTypeId = 0;
                this.roomTypeName = '';
            }

            this.roomTypeModalLoading = false;
        });
    }

    // Transaction Room Type

    @action createRoomType() {
        this.roomTypeModalLoading = true;

        const newRoomType = {
            'roomTypeId': 0,
            'roomTypeName': this.roomTypeName
        };

        return ApiCaller.RoomSetups.apiCreateRoomTypes(newRoomType).then((createRoomTypeResponse) => {
            this.roomTypeModalLoading = false;
            
            if (!createRoomTypeResponse.isError) {
                this.showRoomTypeModal = false;
            }

            return createRoomTypeResponse;
        });
    }

    @action updateRoomType() {
        this.roomTypeModalLoading = true;

        const updateRoomType = {
            'roomTypeId': this.roomTypeId,
            'roomTypeName': this.roomTypeName
        };

        return ApiCaller.RoomSetups.apiUpdateRoomTypes(this.roomTypeId, updateRoomType).then((updateRoomTypeResponse) => {
            this.roomTypeModalLoading = false;

            if (!updateRoomTypeResponse.isError) {
                this.showRoomTypeModal = false;
            }

            return updateRoomTypeResponse;
        });
    }

    @action deleteRoomType(roomTypeId) {
        this.roomTypeListLoading = true;

        return ApiCaller.RoomSetups.apiDeleteRoomTypeById(roomTypeId).then((deleteRoomTypeResponse) => {
            this.roomTypeListLoading = false;

            if (!deleteRoomTypeResponse.isError) {
                this.initRoomType();
            }

            return deleteRoomTypeResponse;
        });
    }

    // SET Properties

    @action setShowRoomTypeModal(value) {
        this.showRoomTypeModal = value;
    }

    @action setRoomTypeName(value) {
        this.roomTypeName = value;
    }
}

export default new RoomTypeStore()